import React from 'react'
import WebService from 'api/explus-api'
import Main from '../../Main'
import ContactUs from './ContactUs'

export default class ContactUsContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      contact: {
        message_type: '',
        message: ''
      },
      loading: false
    }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleClick = this.handleClick.bind(this)
    this.displaySelectedItem = this.displaySelectedItem.bind(this)
  }

  handleChange(event) {
    const target = event.target
    const value = target.value
    const name = target.name

    this.setState({contact: {...this.state.contact, [name]: value}})
  }

  handleClick(value) {
    if (!value) {return}

    return e => {
      e.preventDefault()

      this.setState({
        contact: {...this.state.contact, message_type: value}
      })
    }
  }

  handleSubmit(e) {
    e.preventDefault()
    this.setState({loading: true})
    WebService.contactUs(this.state.contact).then(() => {
      this.setState({loading: false})
    })
  }

  displaySelectedItem() {
    return this.state.message_type
  }

  render() {
    return (
      <Main bannerImage={this.props.bannerImage}>
        <ContactUs loading={this.state.loading} submit={this.handleSubmit} change={this.handleChange} click={this.handleClick} messageType={this.state.contact.message_type || undefined} />
      </Main>
    )
  }
}
